<!-- CONTENIDO DE LAS RESPUESTAS -->
<div #contentResponse class="content-response p-1" *ngIf="chatsIaService.analyticsChat.length > 0">
	<div
		[ngClass]="{
			'content-ia': chat.how === 'ia',
			'content-me': chat.how === 'me',
			'mb-1': idx < chatsIaService.analyticsChat.length - 1
		}"
		*ngFor="let chat of chatsIaService.analyticsChat; let idx = index"
	>
		<div class="vertical-align-left">
			<div>
				<div
					[ngClass]="{ 'bg-me': chat.how === 'me' }"
					class="content"
					[innerHTML]="this.sanitizeHtml(chat.message)"
				></div>
				<div
					[ngClass]="{ 'vertical-align-right': chat.how === 'me', 'vertical-align-left': chat.how === 'ia' }"
					class="animate__fadeIn"
				>
					<i (click)="methodsService.copyPlainText(chat.message)" role="button" class="bi bi-copy fs-12"></i>
				</div>
				<div class="content" *ngIf="chat.configurations.loading === 'loading'">
					<div class="dot"></div>
				</div>
				<div class="content text-muted" *ngIf="chat.configurations.loading === 'error'">
					<div>{{ chat.configurations.message }}</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- END CONTENIDO DE LAS RESPUESTAS -->

<!-- CONTENIDO DE INGRESO DE DATOS -->
<div class="content-input">
	<hr />
	<textarea
		[disabled]="settings.listening"
		#textarea
		[(ngModel)]="prompt"
		placeholder="Escribe aquí tu mensaje…"
		rows="1"
		(keydown.enter)="sendMessage()"
		(input)="adjustTextareaHeight($event)"
	></textarea>

	<div class="content-options">
		<div class="row">
			<div class="col">
				<div class="vertical-align-left">
					<div *ngIf="!chatsIaService.loadings.search">
						<i *ngIf="!settings.listening" class="text-muted bi bi-mic-fill" (click)="startListening()"></i>
						<i
							*ngIf="settings.listening"
							class="text-muted bi bi-stop-circle"
							(click)="stopListening()"
						></i>
						<i
							[ngClass]="{ 'bi-disable': !prompt }"
							*ngIf="!settings.listening"
							class="text-muted bi bi-send"
							(click)="sendMessage()"
						></i>
					</div>
					<div style="margin-left: 10px" *ngIf="settings.listening">Escuchando {{ dots }}</div>
					<i
						*ngIf="chatsIaService.loadings.search"
						(click)="cancelSearch()"
						class="text-muted bi bi-stop-circle-fill"
					></i>
				</div>
			</div>
			<div class="col-auto text-muted fs-12 vertical-align">POWERED BY ZEYO</div>
		</div>
	</div>
</div>
<!-- CONTENIDO DE INGRESO DE DATOS -->
